 document.addEventListener('DOMContentLoaded', function () {
   const kgTargetBlocks = document.querySelectorAll('.kg-product-page-atc-button-block');
   const kgStickyAtcBlocks = document.querySelectorAll('.kg-sticky-atc-button-content-wrapper');
   const body = document.body;


   if (kgTargetBlocks.length && kgStickyAtcBlocks.length) {
    // More accurate visibility check (≥25% visible counts as "in view")
    function kgIsElementInViewport(el, minVisibleRatio = 0.03) {
      if (!el) return false;
      const rect = el.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;
      const visible = Math.max(0, Math.min(vh, rect.bottom) - Math.max(0, rect.top));
      return (visible / rect.height) >= minVisibleRatio;
    }

    function kgHandleVisibility() {
      let anyActive = false;
      const isDesktop = window.innerWidth >= 768; // adjust breakpoint as needed

      kgTargetBlocks.forEach((targetBlock) => {
        const kgTargetProductAtc = targetBlock.querySelector('.kg-product-page-atc-button');
        if (!kgTargetProductAtc) return;

        const inView = kgIsElementInViewport(kgTargetProductAtc);

        kgStickyAtcBlocks.forEach((stickyBlock) => {
          let shouldActivate = false;

          if (isDesktop) {
            // Desktop → show sticky only if static ATC is completely above viewport
            const rect = kgTargetProductAtc.getBoundingClientRect();
            shouldActivate = rect.bottom < 0; 
          } else {
            // Mobile → show sticky when static ATC not in view
            shouldActivate = !inView;
          }

          stickyBlock.classList.toggle('kg-sticky-active', shouldActivate);
          if (shouldActivate) anyActive = true;
        });
      });

      // Toggle body class if any sticky is active
      body.classList.toggle('kg-sticky-any-active', anyActive);
    }

    // Run on scroll, resize, and load
    ['scroll', 'resize', 'load', 'orientationchange'].forEach(evt =>
      window.addEventListener(evt, kgHandleVisibility, { passive: true })
    );

    kgHandleVisibility(); // initial check
     
     document.querySelectorAll('.kg-custom-sticky-atc-button').forEach((btn, index) => {
       btn.addEventListener('click', function (e) {
        // Find the original form and button
        const kgProductForm = document.querySelector('form.kg-product-page-atc-form');
        const kgOriginalButton = kgProductForm?.querySelector('button[type="submit"]');
        // console.log("QQQQQQQQQQQQQQQQQ" + kgOriginalButton);
        // console.log("Selected form:", kgProductForm);
        // console.log("Selected ATC button:", kgOriginalButton);
         e.preventDefault();
         if (kgOriginalButton) {
           kgOriginalButton.click();
           kgProductForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
         }
       });
     });
   }
 });